// src/components/GalleryThumbnail.js
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { imageService } from '../services/ImageService';

const GalleryThumbnail = ({ uid, imageUID, onClick }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    imageService.getImageURL(uid, imageUID, true).then(u => {
      if (isMounted) { setUrl(u); setLoading(false); }
    }).catch(() => {
      if (isMounted) setLoading(false);
    });
    return () => { isMounted = false; };
  }, [uid, imageUID]);

  if (loading) {
    return <div className="aspect-square bg-gray-100 rounded-lg animate-pulse" />;
  }

  if (!url) {
    return (
      <div className="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
        <PhotoIcon className="w-6 h-6 text-gray-300" />
      </div>
    );
  }

  return (
    <div
      className="aspect-square cursor-pointer overflow-hidden rounded-lg hover:opacity-90 transition-opacity"
      onClick={onClick}
    >
      <img src={url} alt="" className="w-full h-full object-cover" loading="lazy" />
    </div>
  );
};

GalleryThumbnail.propTypes = {
  uid: PropTypes.string.isRequired,
  imageUID: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default GalleryThumbnail;
